import React from 'react';

const Pagination = ({ currentPage, lastPage, onPageChange }) => {
    if (lastPage <= 1) {
        return null;
    }

    const renderPageNumbers = () => {
        const pageNumbers = [];
        // Always show the first page
        if (currentPage > 2) {
            pageNumbers.push(1);
            if (currentPage > 3) {
                pageNumbers.push('...');
            }
        }

        // Show current page, and one page before and after
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            if (i > 0 && i <= lastPage) {
                pageNumbers.push(i);
            }
        }

        // Always show the last page
        if (currentPage < lastPage - 2) {
            pageNumbers.push('...');
            pageNumbers.push(lastPage);
        } else if (currentPage === lastPage - 2) {
            pageNumbers.push(lastPage);
        }
        
        // A simplified version for fewer pages
        if (lastPage <= 5) {
            const simplePages = [];
            for (let i = 1; i <= lastPage; i++) {
                simplePages.push(i);
            }
            return simplePages.map(number => (
                <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                    <button 
                        className="page-link rounded-circle border-0 d-flex align-items-center justify-content-center fw-bold" 
                        onClick={() => onPageChange(number)}
                        style={{width: '36px', height: '36px', transition: 'all 0.2s'}}
                    >
                        {number}
                    </button>
                </li>
            ));
        }

        return pageNumbers.map((number, index) => {
            if (number === '...') {
                return <li key={`ellipsis-${index}`} className="page-item disabled"><span className="page-link border-0 bg-transparent text-muted">...</span></li>;
            }
            return (
                <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                    <button 
                        className="page-link rounded-circle border-0 d-flex align-items-center justify-content-center fw-bold" 
                        onClick={() => onPageChange(number)}
                        style={{width: '36px', height: '36px', transition: 'all 0.2s'}}
                    >
                        {number}
                    </button>
                </li>
            );
        });
    };

    return (
        <nav>
            <ul className="pagination pagination-sm mb-0 gap-2 justify-content-center">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button 
                        className="page-link rounded-circle border-0 d-flex align-items-center justify-content-center" 
                        onClick={() => onPageChange(currentPage - 1)}
                        style={{width: '36px', height: '36px'}}
                    >
                        <i className="bi bi-chevron-left"></i>
                    </button>
                </li>
                {renderPageNumbers()}
                <li className={`page-item ${currentPage === lastPage ? 'disabled' : ''}`}>
                    <button 
                        className="page-link rounded-circle border-0 d-flex align-items-center justify-content-center" 
                        onClick={() => onPageChange(currentPage + 1)}
                        style={{width: '36px', height: '36px'}}
                    >
                        <i className="bi bi-chevron-right"></i>
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
